// extracted by mini-css-extract-plugin
export default {"document":"DocumentWrapper_document__TxcqV"};